import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useReturnPendingCard = (returnOrder) => {
  return useQuery({
    queryKey: ["returnOrderPendingCard", returnOrder],
    queryFn: async () =>
      callApi({
        path: "receivedreturnordercard",
        command: "get",
        data: JSON.stringify({
          data: { filter: { noFilter: returnOrder } },
        }),
      }),
  });
};
